<template>
  <div class="ctis-home">
    <div class="ctis-home-bg">
      <Img class="bg" src="/ctis-home-bg.png" />
      <div class="ctis-home-content">
        <div v-if="createPaper">
          <h1>{{ percent >= 100 ? '生成试卷完成' : '生成试卷中...' }}</h1>
          <Progress :percent="percent" :stroke-color="['#76F9DD', '#00D586']" :stroke-width="6" />
          <Button :loading="loading" v-show="percent >= 100" class="btn-center shadow" type="primary" @click="examStart">开始考试</Button>
        </div>
        <div v-else>
          <h1>欢迎进入智谷CTIS区块链考试平台模拟考试系统</h1>
          <p>
            科目：<strong>{{ ctisInfo.subject_name }}</strong>
          </p>
          <Button class="btn-center shadow" type="primary" @click="startCreate">生成模拟试卷</Button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Progress } from 'view-design'
export default {
  components: {
    Progress
  },
  data() {
    return {
      createPaper: false,
      percent: 0,
      loading: false
    }
  },
  computed: {
    ctisInfo() {
      return this.$store.state.ctisInfo
    }
  },
  methods: {
    // 开始生成试卷，开始进度条
    startCreate() {
      this.createPaper = true
      let timer = setInterval(() => {
        this.percent += 1
        if (this.percent >= 100) {
          clearInterval(timer)
          timer = null
        }
      }, 50)
      // 清除定时器
      this.$once('hook:beforeDestroy', () => {
        clearInterval(timer)
        timer = null
      })
    },
    // 开始考试
    async examStart() {
      const params = {
        uriCode: 'API017'
      }
      try {
        this.loading = true
        const res = await this.$fetch(params)
        // 进入考试的时候存储下当前考试信息，下次进入的时候就直接跳转到考试页面
        const examParams = {
          exam_paper_id: res.exam_paper_id,
          eeid: res.eeid,
          end_timestamp: res.valid_timestamp
        }
        // 存储下当前的考试信息，用作回顾或者下次进入的时候直接进入考试页面
        localStorage.setItem('examParams', JSON.stringify(examParams))
        // 记录当前是考试中，交卷后会自动清除
        localStorage.setItem('examing', '1')
        this.$router.push({ name: 'exam', params: { eeid: res.eeid, paper_id: res.exam_paper_id }, query: { end_timestamp: res.valid_timestamp } })
      } finally {
        this.loading = false
      }
    }
  }
}
</script>

<style lang="scss">
.ctis-home {
  width: 100%;
  height: 100%;
  min-height: 100%;
  padding: 43px;
  box-sizing: border-box;
  position: relative;
  background: #f5f8fb;
  &-bg {
    width: 100%;
    height: 100%;
    background: #eaf3f6;
    border-radius: 20px;
    position: relative;
    .bg {
      width: 1200px;
      position: absolute;
      top: 0;
      right: 0;
      bottom: 0;
      left: 0;
      margin: auto;
      z-index: 1;
    }
  }
  &-content {
    width: 460px;
    height: 500px;
    background: rgba(255, 255, 255, 0.89);
    box-shadow: 0px 16px 36px -10px #d0d9dc;
    border-radius: 12px;
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    margin: auto;
    z-index: 2;
    display: flex;
    justify-content: center;
    align-items: center;
    text-align: center;
    & > div {
      height: 290px;
      width: 370px;
    }
    h1 {
      margin-bottom: 100px;
      font-size: 21px;
      line-height: 33px;
    }
    button {
      margin-top: 80px !important;
      width: 225px !important;
      height: 55px !important;
    }
    .ivu-progress-text {
      width: 30px;
    }
  }
}
</style>
